
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Sample } from './sample';

@customElement('sample-view')
export class SampleView extends LitElement {

    static styles = css`
:host {
   position: relative;
   cursor: pointer;
   border: 1px solid #bbb;
   border-radius: 3px;
   margin: 0.0em;
   margin-bottom: 0.5em;
   background-blend-mode: multiply
}
:host :hover {
   background: rgba(255,255,255,0.1);
}

.box {
  padding: 0.4em;
}

:host div :hover {
  background: none;
}
.name {
   font-weight: bold;
   font-size: 1.1em;
}
.cart-button {
   position: absolute;
   top: 1em;
   right: 1em;
   font-size: 1.1em;
   cursor: pointer;
}
.line {
display: flex;
flex-flow: row nowrap;
gap: 0.5em;
}
.sub {
display: inline;
font-weight: normal;
font-size: 0.8em;
}
`;

    @property({ type: Object })
    sample: Sample;

    @property({ type: Boolean })
    in_cart: boolean;

    @property({ type: Boolean })
    subsample: boolean;

    constructor(sample: Sample, in_cart: boolean, subsample: boolean = false) {
        super();
        this.sample = sample;
        this.in_cart = in_cart;
        this.subsample = subsample
    }

    location() {
        return html`<i class="fa fa-location-arrow" aria-hidden="true"></i>
${this.sample.lat.toFixed(3)}, ${this.sample.lon.toFixed(3)}`;
    }
    depth() {
        const z = this.sample.depth;
        if (!z)
            return ``;
        return html`<i class="fa fa-angle-down" aria-hidden="true"></i>${z} m`;
    }
    cart_button() {
        if (!this.in_cart) {
            return html`<div class="cart-button" title="Add to cart" @click=${this.cart}><i class="fa fa-plus" aria-hidden="true"></i></div>`;
        } else {
            return html`<div class="cart-button" title="Remove from cart" @click=${this.cart}><i class="fa fa-minus" aria-hidden="true"></i></div>`;
        }
    }

    sample_id() {
        return this.sample.sample_id;
    }

    name() {
        return this.sample.Full_Sample_Name;
    }

    event(name: string) {
        return new CustomEvent(name, { bubbles: true, composed: true, detail: this.sample });
    }

    cart(ev: Event) {
        ev.stopPropagation();
        this.dispatchEvent(this.event('cart-action'));
    }
    detail(ev: Event) {
        ev.stopPropagation();
        this.dispatchEvent(this.event('sample-detail'));
    }
    subsample_term() {
        if (!this.sample.sub_sample_id)
            return ""
        return html`<div class="sub"> (Subsample)</div>`
    }

    render() {
        if (this.subsample) {
            return html`
<link rel="stylesheet" href="font-awesome-4.7.0/css/font-awesome.min.css">
<div @click=${this.detail}>
<div class="box" >
<div class="line"><div class="name">${this.sample.Full_Sample_Name}</div>subsample</div>
<div>${this.sample.Object_Type} / ${this.sample.Material}</div>
    <div>${this.sample.Sample_Description}</div>
    <div>${this.sample.Sample_Comments}</div>
    <div>${this.cart_button()}</div>
  </div>
</div>
`

        }
        return html`
<link rel="stylesheet" href="font-awesome-4.7.0/css/font-awesome.min.css">
<div @click=${this.detail}>
  <div class="box">
    <div class="name">${this.sample.Full_Sample_Name}${this.subsample_term()}</div>
    <div>${this.sample.Object_Type}</div>
    <div>${this.location()}</div>
    <div>${this.depth()}</div>
    <div>${this.cart_button()}</div>
  </div>
</div>
`
    }
}
